import { callFirebaseFunction } from 'boot/firebase';
import { mapState } from 'pinia';
import { auth } from 'src/store/auth';

export default {

  computed: {
    ...mapState(auth, ['connectedClinic']),
  },

  methods: {

    async updateLicenseUsage(adjustLicenses = false, initStaff = false) {
      await callFirebaseFunction('updateSubscriptionUsage', {
        clinicId: this.connectedClinic.id,
        adjustLicenses,
        initStaff,
      });
    }, // updateLicenseUsage()

  },
};
